export const WORKSPACE_ZONE = 'Asia/Ulaanbaatar';
export const idOf = value => String(value?._id || value?.id || value || '');
export const responseItems = response => Array.isArray(response?.data) ? response.data : response?.data?.items || [];
export function businessDay(value = new Date()) {
  const date = new Date(value);
  if (Number.isNaN(+date)) return '';
  return new Intl.DateTimeFormat('en-CA', { timeZone: WORKSPACE_ZONE, year: 'numeric', month: '2-digit', day: '2-digit' }).format(date);
}
export function dayRange(day) {
  return { startDate: new Date(`${day}T00:00:00+08:00`).toISOString(), endDate: new Date(`${day}T23:59:59.999+08:00`).toISOString() };
}
export function formatWorkspaceDate(value, language = 'ru', options = {}) {
  if (!value) return '—';
  const date = new Date(value.length === 10 ? `${value}T12:00:00+08:00` : value);
  if (Number.isNaN(+date)) return '—';
  return date.toLocaleDateString(language.startsWith('mn') ? 'mn-MN' : language.startsWith('en') ? 'en-GB' : 'ru-RU', { timeZone: WORKSPACE_ZONE, day: 'numeric', month: 'long', ...options });
}
export function formatWorkspaceTime(value, language = 'ru') {
  const date = new Date(value);
  return value && !Number.isNaN(+date) ? date.toLocaleTimeString(language, { timeZone: WORKSPACE_ZONE, hour: '2-digit', minute: '2-digit' }) : '—';
}
export const isMeeting = visit => !visit.type || ['doctor', 'pharmacy'].includes(visit.type);
export const isFinished = visit => visit.status === 'completed' && !!visit.startTime && !!visit.endTime;
export const visitTarget = visit => visit.doctor?.name || visit.doctorName || visit.pharmacyName || visit.eventName || visit.hospital || '';

export function buildDayModel(visits, plans, users, day) {
  const map = new Map();
  [...plans, ...visits].forEach(v => { if (idOf(v)) map.set(idOf(v), { ...map.get(idOf(v)), ...v }); });
  // Old plan/fact pairs can have different IDs. Only collapse an explicit link.
  for (const record of map.values()) if (record.linkedPlan && record.startTime) {
    const planId = idOf(record.linkedPlan);
    if (planId !== idOf(record) && map.has(planId)) map.delete(planId);
  }
  const records = [...map.values()].filter(v => ((v.plannedDate || v.startTime) && businessDay(v.plannedDate || v.startTime) === day) || (v.startTime && businessDay(v.startTime) === day));
  const meetings = records.filter(isMeeting);
  const completed = meetings.filter(v => isFinished(v) && businessDay(v.startTime) === day);
  const active = meetings.filter(v => v.status === 'in_progress' && !!v.startTime);
  const planned = meetings.filter(v => !!v.plannedDate && businessDay(v.plannedDate) === day && v.status !== 'cancelled');
  const people = users.map(user => {
    const own = records.filter(v => idOf(v.user) === idOf(user));
    return { ...user, planned: planned.filter(v => idOf(v.user) === idOf(user)).length, completed: completed.filter(v => idOf(v.user) === idOf(user)).length,
      active: active.filter(v => idOf(v.user) === idOf(user)).length, dayoff: own.some(v => v.type === 'dayoff' && v.status !== 'cancelled'),
      last: own.filter(v => v.startTime).sort((a, b) => +new Date(b.startTime) - +new Date(a.startTime))[0]?.startTime || null };
  });
  return { records: records.sort((a,b) => +new Date(a.plannedDate || a.startTime) - +new Date(b.plannedDate || b.startTime)), completed, active, planned, people };
}
